export const downloadCanvasAsPng = (canvas: HTMLCanvasElement, svgUrl: string): void => {
  canvas.toBlob((blob) => {
    if (!blob) {
      console.error("Failed to create blob");
      URL.revokeObjectURL(svgUrl);
      return;
    }

    const downloadUrl = URL.createObjectURL(blob);
    const filename = generateFilename();
    triggerDownload(downloadUrl, filename);

    URL.revokeObjectURL(svgUrl);
    URL.revokeObjectURL(downloadUrl);
  }, "image/png");
};

const generateFilename = (): string => {
  const pageTitle = getPageTitle();
  const pagePath = getPagePath();
  const date = getTodayDate();
  return `${pageTitle}_${pagePath}_${date}.png`;
};

const getPageTitle = (): string => {
  const title = document.title || "unknown";
  return sanitizeFilename(title);
};

const getPagePath = (): string => {
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter((segment) => segment !== "");
  return segments.length > 0 ? segments[0] : "unknown";
};

const sanitizeFilename = (filename: string): string => {
  return filename
    .replace(/[<>:"/\\|?*]/g, "_")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
};

const getTodayDate = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

const triggerDownload = (downloadUrl: string, filename: string): void => {
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
